"use strict";

exports.__esModule = true;
exports.default = void 0;
var _StatusBar = _interopRequireDefault(require("./StatusBar.js"));
exports.default = _StatusBar.default;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }